import { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/Footer.jsx";
import { useTranslation } from 'react-i18next';

const ClientAdmin = () => {
    const { t } = useTranslation();
    const [customers, setCustomers] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    useEffect(() => {
        checkAdminStatus();
    }, []);
    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(isAdmin);

        if (isAdmin) {
            fetchAllCustomers();
        } else {
                return;
        }
    };
    const fetchAllCustomers = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                return;
            }
    
            const response = await axios.get('  https://rehabwmg.online/api/admin/customers', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
    
            if (response.status === 200) {
                setCustomers(response.data);
            } else {
                return;
            }
        } catch (error) {
                return;
        }
    };
  const filteredCustomers = customers.filter((customer) => {
  const lowerSearch = searchTerm.toLowerCase();
  return (
    customer.Name?.toLowerCase().includes(lowerSearch) ||
    customer.SupplierCustomID?.toString().toLowerCase().includes(lowerSearch) ||
    customer.idsOrder?.toString().includes(lowerSearch)
  );
});

    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }
    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex">
                <section className="w-100 p-3">
                     <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
    <h1 className="text-dark display-4 m-0">{t('Tableau_de_bord_Clients')}</h1>
    <input
        type="text"
        className="form-control w-auto"
  placeholder={t('Rechercher_par_nom_id')}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ maxWidth: '300px' }}
    />
</div>
                    <hr className="my-4" />

                    {/* Customers Table - Make it responsive */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th>{t('ID_Fournisseur')}</th>
                                    <th>{t('Nom')}</th>
                                    <th>{t('Numéro_de_Téléphone')}</th>
                                    <th>{t('Adresse')}</th>
                                    <th>{t('Cree_le')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCustomers.map((customer) => (
                                    <tr key={customer.CustomerID}>       
                                        <td>{customer.SupplierCustomID}</td>
                                        <td>{customer.Name}</td>
                                        <td>{customer.Phone || 'N/A'}</td>
                                        <td>{customer.Address}</td>
                                        <td>{new Date(customer.created_at).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default ClientAdmin;
